import React, { useState, useEffect } from 'react';

interface PlayerNameInputOverlayProps {
  isVisible: boolean;
  currentScore: number;
  onSubmitName: (name: string) => void;
  onClose: () => void;
}

const PlayerNameInputOverlay: React.FC<PlayerNameInputOverlayProps> = ({
  isVisible,
  currentScore,
  onSubmitName,
  onClose,
}) => {
  const [name, setName] = useState<string>('');

  useEffect(() => {
    // Reset name when overlay becomes visible, e.g. for a new game over
    if (isVisible) {
      setName('');
    }
  }, [isVisible]);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    const trimmedName = name.trim();
    if (trimmedName) {
      onSubmitName(trimmedName);
    } else {
      // If name is empty, submit with a default name
      onSubmitName("AnonymousBird"); 
    }
  };

  if (!isVisible) {
    return null;
  }

  // Basic inline styles for the overlay. Can be moved to a CSS file later.
  const overlayStyle: React.CSSProperties = {
    position: 'fixed', // Use fixed to overlay the entire viewport
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    backgroundColor: 'rgba(40, 40, 60, 0.9)', // Darker, slightly transparent
    padding: '30px',
    borderRadius: '15px',
    border: '2px solid #FFF',
    color: 'white',
    zIndex: 200, 
    fontFamily: '"Press Start 2P", Courier, monospace',
    textAlign: 'center',
    boxShadow: '0 0 20px rgba(0,0,0,0.5)',
  };

  const inputStyle: React.CSSProperties = {
    padding: '10px',
    margin: '15px 0',
    fontFamily: '"Press Start 2P", Courier, monospace',
    fontSize: '18px',
    backgroundColor: '#333',
    color: '#FFF',
    border: '1px solid #777',
    borderRadius: '5px',
    width: 'calc(100% - 22px)', // Account for padding
  };

  const buttonStyle: React.CSSProperties = {
    padding: '12px 18px',
    backgroundColor: '#90EE90', // Light green
    color: '#000',
    border: 'none',
    borderRadius: '5px',
    fontFamily: '"Press Start 2P", Courier, monospace',
    fontSize: '16px',
    cursor: 'pointer',
    display: 'block',
    margin: '15px auto 0 auto',
    minWidth: '120px',
  };
  
  const cancelButtonStyle: React.CSSProperties = {
    ...buttonStyle,
    backgroundColor: '#f44336', // Red
    color: 'white',
    marginTop: '10px',
  };

  return (
    <div style={overlayStyle}>
      <h3 style={{ fontSize: '24px', marginBottom: '10px' }}>GAME OVER!</h3>
      <p style={{ fontSize: '20px', marginBottom: '20px' }}>Your Score: {currentScore}</p>
      <form onSubmit={handleSubmit}>
        <div>
          <label htmlFor="playerName" style={{ display: 'block', marginBottom: '5px', fontSize: '16px' }}>
            Enter Your Name:
          </label>
          <input
            type="text"
            id="playerName"
            value={name}
            onChange={(e) => setName(e.target.value)}
            maxLength={15} // Keep names reasonably short
            style={inputStyle}
            autoFocus
          />
        </div>
        <button type="submit" style={buttonStyle}>
          Submit Score
        </button>
      </form>
      <button onClick={onClose} style={cancelButtonStyle}>
        Skip / Menu
      </button>
    </div>
  );
};

export default PlayerNameInputOverlay;
// Rewrite Count: 1